import React, { useEffect, useRef, useState } from "react";
import { Box } from "@mui/material";
import {
  CustomSectionTitle,
  PropertyRegistrationTabs,
} from "@ippon/shared-components";
import CustomFormSettingPage from "../CustomForm/index.tsx";
import CustomPulldownTab from "./CustomPulldownTab";

const CUSTOM_SETTING_TABS = [
  { id: 0, label: "フォーム" },
  { id: 1, label: "プルダウン" },
];

/**
 * 設定 > カスタム設定。
 * 従来の「カスタムフォーム」設定ページを格上げし、
 * 「カスタムフォーム」(追加項目) と「カスタムプルダウン」(選択肢マスタ) を
 * タブで束ねる上位ページ。タブは物件詳細・収支と同じカード風タブ
 * (PropertyRegistrationTabs) を使用する。
 */
const CustomSettingPage: React.FC = () => {
  const [tab, setTab] = useState(0);
  const wrapRef = useRef<HTMLDivElement>(null);
  const [panelHeight, setPanelHeight] = useState<number | null>(null);

  // グレーのカード枠を「自分の上端から画面下端まで」の高さにして常に最下部まで満たす。
  //   上に何 (タイトル/パンくず) があっても実測で追従するので calc のマジックナンバーが不要。
  //   この固定高さにより、scrollableContent でタブを固定したままコンテンツだけが内部スクロールする。
  useEffect(() => {
    const measure = () => {
      const el = wrapRef.current;
      if (!el) return;
      const top = el.getBoundingClientRect().top;
      setPanelHeight(Math.max(0, window.innerHeight - top));
    };
    measure();
    window.addEventListener("resize", measure);
    return () => window.removeEventListener("resize", measure);
  }, []);

  return (
    <Box pt={{ xs: 2, sm: 3 }}>
      <CustomSectionTitle title="カスタム設定" addBorder size="large" />
      {/* 白カードを浮かせるため全幅グレー背景で包む (DashboardLayout の pl=24/32・pr=24 を
          負マージンで打ち消して全幅化)。高さは実測で画面下端まで満たす。 */}
      <Box
        ref={wrapRef}
        sx={{
          backgroundColor: "#f5f5f5",
          // カスタム設定は左 padding 24px なので全幅化の負マージンも -3 で揃える
          ml: -3,
          mr: -3,
          pt: 1.7,
          px: 2,
          height: panelHeight ? `${panelHeight}px` : "auto",
          minHeight: 0,
          display: "flex",
          flexDirection: "column",
          overflow: "hidden",
        }}
      >
        <PropertyRegistrationTabs
          currentTab={tab}
          tabs={CUSTOM_SETTING_TABS}
          onTabChange={setTab}
          disableConfirm
          hasFixedActionBar
          scrollableContent
        >
          {tab === 0 ? (
            <CustomFormSettingPage embedded />
          ) : (
            <CustomPulldownTab />
          )}
        </PropertyRegistrationTabs>
      </Box>
    </Box>
  );
};

export default CustomSettingPage;
